import '../../style/';
import './index.less';



// WEBPACK FOOTER //
// ./components/wing-blank/style/index.tsx